import { JSX, useState, useEffect, useRef } from 'react';
import TodoManager from '../../todolist/data/todoManager';
import './todoPreview.css';
import TodoTaskView from './todoTaskView';
import {TodoTask} from '../../todolist/add-todo/addTodoList';
import WindowBar from '../../common/windowBar/windowBar';
import TodoIcon from '../../assets/images/Clipboard.png';

const TodoPreview = ({ setLoading, topRef, maxHeight }: { setLoading: (loading: boolean) => void, topRef?: React.RefObject<any>, maxHeight?: number }): JSX.Element => {
    const todoManager = TodoManager.getInstance();
    const [todos, setTodos] = useState<TodoTask[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const windowBarRef = useRef(null);
    const [windowBarHeight, setWindowBarHeight] = useState(0);

    const refreshTodos = async () => {
        try {
            const fetchedTodos = await todoManager.getTodos(); // Now waits for initialization
            setTodos([...fetchedTodos]);
        } catch (error) {
            console.error('Failed to fetch todos:', error);
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        // Subscribe to updates
        const unsubscribe = todoManager.subscribe(refreshTodos);
        
        // Initial load
        refreshTodos();

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        refreshTodos();
    }, []);

    useEffect(() => {
        const updateWindowBarHeight = () => {
            console.log("bar window recalculate")
            if (windowBarRef.current) {
                const barHeight = windowBarRef.current.getBoundingClientRect().height;
                setWindowBarHeight(barHeight);
                console.log(`windows bar height: ${barHeight}`);
            }
        };
    
        // Create a slight delay to ensure the DOM is ready
        const timeoutId = setTimeout(() => {
            updateWindowBarHeight();
          }, 200); 
        
        // Also add resize observer to handle dynamic size changes
        const resizeObserver = new ResizeObserver(updateWindowBarHeight);
        if (windowBarRef.current) {
            resizeObserver.observe(windowBarRef.current);
        }
    
        return () => {
            clearTimeout(timeoutId);
            resizeObserver.disconnect();
        };

    }, []);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div className='todo-preview-outter-container outter-container' ref={topRef}>
            <div className='pixel-container-back'/>
            <div className='pixel-container-top'>
                <div className='pixel-container-border'>
                    <WindowBar IconSrc={TodoIcon} title='Todo Preview' onClick={()=>{}} barRef={windowBarRef}/>
                    <div className='main-pixel-container todos-container' style={{ 
                    maxHeight: `calc(${maxHeight}px - ${windowBarHeight}px - 10px)`,
                    overflowY: 'auto'
                    }}>
                        {todos.map(todo => (
                            <TodoTaskView todo={todo} key={todo._id}
                                onUpdate={refreshTodos}/>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    ); 
};
  
export default TodoPreview;
